import BigNumber from 'bignumber.js'
import { ChainIdEnum } from 'config/constants/network'
import tokens from 'config/constants/tokens'
import { BonusTagEnums, WageringBonusStatusEnums } from 'config/types/bonus'
import { FreespinDepositBonus, WageringConditionBonus } from 'config/types/bonus/userBonus'
import { Trans } from 'react-i18next'
import { useTokenUsdPrices } from 'state/app/hooks'
import styled from 'styled-components'
import { BoxProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import {
  estimateFiatDecimalValues,
  formatDisplayEstimateFiat,
  isFreeSpinBonusFiatReward,
  isWagerBonusFiatReward,
} from 'utils/bonus'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { BonusContentFieldTitle, BonusContentGridSystem } from '../styled'

const DepositBonusCondition: React.FC<{ bonus: WageringConditionBonus } & BoxProps> = ({ bonus, ...props }) => {
  // TODO improve this logic in bonus class
  const isDeposited =
    !(bonus instanceof FreespinDepositBonus) && bonus?.wageringBonusStatus === WageringBonusStatusEnums.WaitingSpin
  const tokenUsdPrices = useTokenUsdPrices()

  return (
    <>
      <BonusContentGridSystem {...props}>
        <BonusContentFieldTitle>
          <Trans>Min Deposit</Trans>
        </BonusContentFieldTitle>
        <BonusContentFieldTitle fontSize="12px">
          <Text fontWeight="600" fontSize="inherit">
            {bonus.tags.includes(BonusTagEnums.NoDeposit) ? (
              <Trans>No deposit</Trans>
            ) : (
              <>
                {isDeposited && <Trans>Done</Trans>}
                {!isDeposited && (
                  <>
                    ${getFullDisplayBalance(bonus.minDepositBigAmount)}{' '}
                    {isFreeSpinBonusFiatReward(bonus) && (
                      <StyledFiatEstimated>
                        {formatDisplayEstimateFiat(
                          bonus.minDepositBigAmount
                            .dividedBy(tokenUsdPrices[(bonus as any).freeSpinCurrency])
                            .toFixed(
                              estimateFiatDecimalValues(tokens[ChainIdEnum.FIAT][(bonus as any)?.freeSpincurrency]),
                              BigNumber.ROUND_UP,
                            ),
                          (bonus as any).freeSpinCurrency,
                        )}
                      </StyledFiatEstimated>
                    )}
                    {isWagerBonusFiatReward(bonus) && (
                      <StyledFiatEstimated>
                        {formatDisplayEstimateFiat(
                          bonus.minDepositBigAmount
                            .dividedBy(tokenUsdPrices[bonus.bonusAmount.token.code])
                            .toFixed(
                              estimateFiatDecimalValues(tokens[ChainIdEnum.FIAT][bonus.bonusAmount.token.code]),
                              BigNumber.ROUND_UP,
                            ),
                          bonus.bonusAmount.token.code,
                        )}
                      </StyledFiatEstimated>
                    )}
                  </>
                )}{' '}
              </>
            )}
          </Text>
        </BonusContentFieldTitle>
      </BonusContentGridSystem>
      {!!bonus.wagerMultiplier && (
        <BonusContentGridSystem mt="8px">
          <BonusContentFieldTitle>
            <Trans>Wager</Trans>
          </BonusContentFieldTitle>
          <Text fontWeight="600" fontSize="12px">
            x{bonus.wagerMultiplier}
          </Text>
        </BonusContentGridSystem>
      )}
    </>
  )
}

const StyledFiatEstimated = styled(Text).attrs({ as: 'span' })`
  color: ${({ theme: { colors } }) => colors.textSubtle};
  font-size: inherit;
  font-weight: inherit;
`

export default DepositBonusCondition
